import { GridRowSelectionModel } from '@mui/x-data-grid';

import { AxiosPromise } from 'axios';

import { Evaluation } from '@/models/evaluations';
import { UnknownObject } from '@/models/misc';

import { decomposeParams, api } from '.';

export const getEvaluations = (
  params?: Evaluation.ListParams
): AxiosPromise<Evaluation.EvaluationsResponse> =>
  api.get(`v2/evaluations${decomposeParams(params)}`);

export const getEvaluation = (id: number) => api.get(`v2/evaluations/${id}`);
export const getAuthors = () => api.get(`/v2/evaluations/authors`);

export const createEvaluation = (payload: UnknownObject) =>
  api.post(`v2/evaluations`, payload);

export const updateEvaluation = (id: number, payload: UnknownObject) =>
  api.put(`v2/evaluations/${id}`, payload);

export const deleteEvaluation = (payload: UnknownObject) =>
  api.delete(`v2/evaluations`, { data: payload });

export const previewEvaluation = (
  params: UnknownObject,
  signal?: AbortSignal
) => api.post(`v2/evaluations/preview`, params, { signal });

export const evaluationTitleExists = (title: string) =>
  api.get(`filters/title/${encodeURIComponent(title)}`);

export const deleteEvaluationPosts = (
  payload: UnknownObject
): AxiosPromise<{
  deleted: Array<number>;
  notDeleted: Array<number>;
}> => api.delete(`v2/evaluations/posts`, { data: payload });

export const getEvaluationReport = (
  id: number,
  params: UnknownObject,
  payload: UnknownObject
) =>
  api.post(
    `v2/evaluations/report-test/${id}${decomposeParams(params)}`,
    payload
  );

export const getEvaluationStatistics = (
  id: number,
  params: Evaluation.StatisticsParams
): AxiosPromise<Evaluation.Statistics> =>
  api.get(`v2/evaluations/${id}/statistics${decomposeParams(params)}`);

export const exportEvaluationCSV = (
  params: Evaluation.FilteringParams,
  payload: {
    postIds: GridRowSelectionModel;
  }
): AxiosPromise<Blob> =>
  api.post(`v2/posts/export${decomposeParams(params)}`, payload, {
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/csv'
    }
  });
